import { Pane, PaneProps } from 'evergreen-ui';
import { stationSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { useIsStationAdmin } from 'Features/StationsNew/Hooks';
import { useGeneralStationsStyles } from 'Features/StationsNew/useStyles';
import React from 'react';
import { useSelector } from 'react-redux';
import { IconControlsProps, StationIconControls } from './StationIconControls';
import ShowStationOnMap from './ShowStationOnMap';
import StationMenu from './StationMenu';
import StationName from './StationName';

interface StationNavigationRowProps extends PaneProps {
  stationId: number,
  isExpanded?: IconControlsProps['isExpanded'],
  withoutMenu?: boolean,
}

/** Cтрока навигации по станции с данными из словарей общего `redux-store` */
export function StationNavigationRow({
  className = '',
  stationId,
  isExpanded = false,
  withoutMenu = false,
  ...props
}:StationNavigationRowProps) {
  const classes = useGeneralStationsStyles();
  const station = useSelector(stationSelector(stationId));
  const isStationAdmin = useIsStationAdmin(stationId);

  return (
    <Pane className={`${classes.pageNavigationRow} ${className}`} {...props}>
      <ShowStationOnMap stationId={stationId} />
      <StationName station={station} />
      <StationIconControls flexGrow={1} stationId={stationId} isExpanded={isExpanded} />
      {!withoutMenu ? <StationMenu station={station} isStationAdmin={isStationAdmin} /> : null}
    </Pane>
  );
}
export const MemoStationNavigationRow = React.memo(StationNavigationRow);
MemoStationNavigationRow.displayName = 'MemoStationNavigationRow';
export default StationNavigationRow;
